import { createContext, useContext } from 'react';
export const FormFieldsContext = /*#__PURE__*/createContext(undefined);
export function useFormFields() {
  const context = useContext(FormFieldsContext);
  if (context === undefined) {
    throw new Error('useFormFields must be used within a FormFieldsProvider');
  }
  return context;
}
//# sourceMappingURL=form-fields-context.js.map